<template>
<div>
  <comment-item :data="data" :author="author"></comment-item>
  <template v-if="data.reply">
    <button
      v-if="data.reply.length"
      class="btn btn-link btn-info ml-5 border-0"
      style="padding-left:0px;font-size:15px;color: #0285b9"
      v-on:click="show_reply_div=!show_reply_div">
      {{show_reply_div?'隐藏':'显示'}} {{data.reply.length}} {{$t('message').article.reply_count}}
<!--      <span class="ml-2" v-if="has_author">[包含作者回复]</span>-->
    </button>
  </template>

  <div class="pl-5" v-if="show_reply_div">
    <comment-item v-for="r in data.reply" :key="r.postID" :data="r" :author="author" :level="2"></comment-item>
  </div>
</div>
</template>
<script>
import CommentItem from './CommentItem.vue';
import {  Button } from '@/components';
import icons from "@/components/Icons/Icons";

export default {
  name: 'comment',
  props:{
    data:{},
    author:Number,
  },
  watch:{
    "data.reply":function(){
      this.show_reply_div = true;
    }
  },
  components: {
    CommentItem,
    [Button.name]: Button,
  },
  mounted: function () {
    let userinfor = this.$store.state.user.userinfo
    this.loginuserID = userinfor?userinfor.UserID:-1;
  },
  computed:{
    has_author () {
      let s = 0
      this.data.reply.forEach(obj=>{
        if(obj.userID == this.author) {
          s++
        } ;
      })
      return s>0?true:false
    }
  },
  methods:{
    // 删除回复
    article_reply_delete(item){
      blog.reply_delete(item.postID).then(res=>{
        if(res.status){
          this.regetComment(item);
        }
      })
    },
    admin_reply_delete(item,visible){
      this.$store.state.user.admin_reply_delete(item.postID,visible).then(res=>{
        if(res.status){
          item.visible = visible
        }
      })
    },
    regetComment(item){
      let id = 0;
      if(item.treelevel==2){
        id = item.basecode;
      }else{
        id = item.postID;
      }
      this.$emit("regetcomment",id);
    },
    checkstatus(type){
      if(type==1){
        this.replybtndisable = this.reportmsgbody?false:true;
      }else{
        this.replybtndisable = this.replymsgbody?false:true;
      }
    },
    replystatus(id){
      let obj = document.getElementById(id);
      obj.style.display = obj.style.display=='none'?'block':'none';
      this.replyshowstatus = obj.style.display=='none'?'显示':'隐藏';
    },
    wrapToBr(text) {
      var string = text;
      try {
        string = string.replace(/\r\n/g, "<br>")
        string = string.replace(/\n/g, "<br>");
        string = string.replace(/\r/g, "<br>");
        string = string.replace(/\s/g,"&nbsp;");
      } catch (e) {
        // console.log(e.message);
      }
      return string;
    }
  },
  data(){
    return {
      show_reply_editor:false,
      show_reply_div:false,
      show_reply_2:false,
      loginuserID:-1,
      replyshowstatus:'显示',
      replymsgbody:'',
      reportmsgbody:'',
      report_status:false,
      replyusername:'',
      replybtndisable:true,
      noMore:false,
      currentItem:{userinfo_userID:{username:''}},
      modals: {
        reply: false,
        delete: false,
        login:false
      },
    }
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  }

};
</script>
<style>

.fontsize0 .comment .replyContent{
  font-size: 1rem;
}
.fontsize1 .comment .replyContent{
  font-size: 1.2rem;
}
.fontsize2 .comment .replyContent{
  font-size: 1.4rem;
}
.groupEditar{
  height:250px;
}
.comment .replyContent,.comment .replyFoot{
  font-size: 1rem;
  margin-bottom: 3px;
}
.comment .replyName{
  font-weight: 700;
}
.comment .replyTime{
  color:gray;
  font-size: .875rem;
  margin-left: 1rem;
}
.comment .haiwaiicon svg{
  fill:grey
}
@media (max-width: 575.98px){

}
</style>
